var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationBlackIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.6665C11.3807 11.6665 12.5 10.5472 12.5 9.1665C12.5 7.78579 11.3807 6.6665 10 6.6665C8.61929 6.6665 7.5 7.78579 7.5 9.1665C7.5 10.5472 8.61929 11.6665 10 11.6665Z",
    stroke: "#3F3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7143 13.8806L11.1785 17.4164C10.866 17.7286 10.4423 17.904 10.0006 17.904C9.55885 17.904 9.13518 17.7286 8.82267 17.4164L5.286 13.8806C4.35368 12.9482 3.71878 11.7603 3.46157 10.4671C3.20437 9.17394 3.33641 7.83352 3.841 6.61536C4.3456 5.39721 5.20008 4.35604 6.2964 3.62351C7.39272 2.89098 8.68164 2.5 10.0002 2.5C11.3187 2.5 12.6076 2.89098 13.7039 3.62351C14.8003 4.35604 15.6547 5.39721 16.1593 6.61536C16.6639 7.83352 16.796 9.17394 16.5388 10.4671C16.2816 11.7603 15.6466 12.9482 14.7143 13.8806V13.8806Z",
    stroke: "#3F3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBlackIcon);
export default __webpack_public_path__ + "static/media/LocationBlackIcon.af12cc1a10e33843a4904294ba82db97.svg";
export { ForwardRef as ReactComponent };